import { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import StyledSwitch from "@/components/ui/customs/StyledSwitch";
import { ControlledUnifiedInput } from "@/components/ui/customs/controlled-unified-input";
import { ExpeditionBoDeliveryInfoFormData } from "@/types/forms/bo/expeditionBo.form";

export const MrnNumbers = () => {
  const { t } = useTranslation("boExpeditionForm");
  const { control, getValues, setValue } = useFormContext<ExpeditionBoDeliveryInfoFormData>();

  const daeEnabled = useWatch({ control, name: "options.dae" });
  const mrnEnabled = useWatch({ control, name: "options.mrn" });
  const itemsCount = useWatch({ control, name: "options.mrnNumbers" })?.length ?? 0;

  useEffect(() => {
    if (!daeEnabled && getValues("options.mrn")) {
      setValue("options.mrn", false, { shouldDirty: true });
    }
  }, [daeEnabled, getValues, setValue]);

  useEffect(() => {
    if (!daeEnabled || !mrnEnabled) {
      if (itemsCount > 0) {
        setValue("options.mrnNumbers", [], { shouldDirty: true });
      }
      return;
    }
    if (itemsCount === 0) {
      setValue("options.mrnNumbers", [""], { shouldDirty: true });
    }
  }, [daeEnabled, mrnEnabled, itemsCount, setValue]);

  if (!daeEnabled) return null;

  return (
    <div className="flex w-full flex-col gap-2 @xl:flex-row @xl:items-start @xl:gap-2">
      <div className="flex flex-1 flex-row items-center gap-2 @xl:h-9">
        <StyledSwitch control={control} name="options.mrn" />
        <span className="w-24 shrink-0 text-sm font-medium text-gray-800">MRN</span>
      </div>
      <div className="flex w-full flex-col gap-2">
        {mrnEnabled && (
          <ControlledUnifiedInput
            control={control}
            name="options.mrnNumbers.0"
            placeholder={t("mrnNumbers.numberPlaceholder")}
            wrapperClassName="flex-1"
          />
        )}
      </div>
    </div>
  );
};
